import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetRoles_roles as Roles, GetRoles as GetRolesQuery} from 'nutshell-graphql-types';

import GET_ROLES from '../queries/get-roles.graphql';

export function useGetRoles(): {
    roles: Roles[];
    isLoading: boolean;
    error: string | null | undefined;
} {
    const {data, error, loading} = useQuery<GetRolesQuery, Record<any, any>>(GET_ROLES, {});

    const roles = data ? data.roles.sort((a, b) => a.position - b.position) : [];

    return {
        roles,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
